import { useMemo } from "react";

import Timestamp from "components/Timestamp";
import { makeTimestampToCopy } from "ds/components/Table/helpers";

import useCellCopyAction from "../../useCellCopyAction";
import IntentProjectEnvironmentMountedFilesTableCell from "../Cell";
import { IntentProjectEnvironmentMountedFilesTableCellContentProps } from "../types";

const IntentProjectEnvironmentMountedFilesTableCreatedAtCell = ({
  item,
  ...cellProps
}: IntentProjectEnvironmentMountedFilesTableCellContentProps) => {
  const value = item.createdAt || 0;
  const copyAction = useCellCopyAction({
    text: makeTimestampToCopy(value),
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <IntentProjectEnvironmentMountedFilesTableCell {...cellProps} actions={actions}>
      <Timestamp timestamp={value} />
    </IntentProjectEnvironmentMountedFilesTableCell>
  );
};

export default IntentProjectEnvironmentMountedFilesTableCreatedAtCell;
